import { render, staticRenderFns } from "./OpenMarket.vue?vue&type=template&id=7d11c6a1&"
import script from "./OpenMarket.vue?vue&type=script&lang=js&"
export * from "./OpenMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports